import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
        _createElementVNode("h1", null, "All Orders", -1)
    ])));
}
